import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import './styles.scss'
import ComponentLoader from '../component-loader'
import { getComponentLabel } from '../../helper'
import { environment } from '../../../../../environment'

class SectionBox2Column extends PureComponent {
  render () {
    const sectionId = this.props.blueprint.id
    const section = this.props.factsheetBlueprint.factTree.sections[sectionId]
    const label = getComponentLabel(
      this.props.blueprint,
      section)
    return (
      <div className={'section-box-2-column'}>
        {label &&
        <div>
          <h3 className={'section-title'}>{label}</h3>
        </div>
        }
        <div className={'section-box-2-column-content'}>
          {this.props.blueprint.components.map((component, index) => {
            const keyUsed = component && component.id ? component.id : `${this.props.blueprint.id}:i${index}`
            if (environment.IS_DEV && window.__LOG_FS_KEYS) {
              if (!component || !component.id) {
                console.warn('Factsheet key fallback used in SectionBox2Column', {
                  parentId: this.props.blueprint.id,
                  index,
                  component
                })
              }
              console.debug('Factsheet key used (SectionBox2Column):', keyUsed)
            }
            return <ComponentLoader key={keyUsed} blueprint={component}
                                    parentBlueprint={this.props.blueprint}
                                    factsheetBlueprint={this.props.factsheetBlueprint}/>
          })}
        </div>
      </div>
    )
  }
}

SectionBox2Column.propTypes = {
  blueprint: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired
}
export default SectionBox2Column
